/* Autel Diagnostic Tools - Custom JS Enhancements */
(function() {
  'use strict';

  /* Intersection Observer for fade-in animations */
  function initAnimations() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.card-wrapper, .multicolumn-card, .collection-list__item').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

  /* Smooth scroll for anchor links */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* Header shadow on scroll */
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    
    var scrollHandler = function() {
      if (window.scrollY > 50) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.3)';
      } else {
        header.style.boxShadow = 'none';
      }
    };
    
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  /* Initialize on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAnimations();
      initSmoothScroll();
      initHeaderScroll();
    });
  } else {
    initAnimations();
    initSmoothScroll();
    initHeaderScroll();
  }
})();
